import { Component, OnInit, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonFieldWidgetBase } from '../common-field-widget-base';
import { CommonNumberField } from '../field';
import { getLabels } from '../field.labels';


@Component({
	selector: 'common-number-field',
	imports: [FormsModule],
	templateUrl: './common-number-field.widget.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	host: { '[class.d-none]': 'isExcluded()' },
})
export class CommonNumberFieldWidget extends CommonFieldWidgetBase<number | undefined, CommonNumberField> implements OnInit {

	public readonly field = input.required<CommonNumberField>();

	public min = computed<number>(() => this.field().config().min ?? 0);
	public max = computed<number>(() => this.field().config().max ?? 100);

	public readonly type = computed(() => this.hasFocus() ? 'number' : 'text')

	public readonly labels = computed(() => {
		const config = this.field().config();

		return {
			...getLabels(config.isSpanish),

			// Set custom min and max length labels based on calculated min and max lengths
			minLength: config.isSpanish ? `El número debe ser mayor que ${this.min()}.` : `Number must be greater than ${this.min()}.`,
			maxLength: config.isSpanish ? `El número debe ser menor que ${this.max()}.` : `Number must be less than ${this.max()}.`
		}

	});


	public readonly renderedModel = computed(() => {
		const pendingValue = this.field().pendingValue();
		const value = pendingValue !== null ? pendingValue : this.field().actualValue();
		return this.render(value);
	});


	ngOnInit() {
		this.onInit(this.field());
	}


	public onChange(value: string) {
		const num = value === '' ? undefined : parseInt(value);
		this.processChange(num);
	}


	public async onBlur() {
		await this.processBlur();
	}


	protected override cleanValue(value: number | undefined): number | undefined {
		if (value && value > 0) value = Math.round(value);
		if (value == 0 && this.field().config().saveZeroAsNull) value = undefined;
		return value;
	}


	protected override render(value: number | undefined) {
		if (this.hasFocus() || this.error()) return value;
		return value?.toLocaleString();
	}


	protected validate(value: number | undefined): string {

		if (value && value > 0) value = Math.round(value);
		const config = this.field().config();
		const labels = this.labels();

		if (config.isRequired && value == undefined && value == null) return labels.missingRequired();
		if (value !== undefined && value !== null && value > this.max()) return labels.maxLength;
		if (value !== undefined && value !== null && value < this.min()) return labels.minLength;

		return '';
	}


	public setFocus() {
		console.error('setFocus() not implemented');
	}

}